


















































































































import Vue, { PropType } from 'vue';
import { OptionsFieldInterface, typeMultiselect } from '@/types';
import Multiselect from 'vue-multiselect';
import ChipsElement from '@/components/chips/ChipsElement.vue';

export default Vue.extend({
  name: 'FieldMultipleSelect',
  components: { Multiselect, ChipsElement },
  props: {
    name: { type: String },
    value: {
      type: Array as PropType<Array<any>>,
      required: false,
      default: () => [],
    },
    typeValue: {
      type: [String, Number] as PropType<string | number>,
      required: false,
      default: () => '',
    },
    label: { type: String },
    hint: { type: String },
    options: {
      type: Array as PropType<Array<OptionsFieldInterface>>,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    pushTags: {
      type: Boolean,
      default: true,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewCountSelected: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'multipleselect',
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    isTypeSelect: {
      type: Boolean,
      default: false,
    },
    hideSelected: {
      type: Boolean,
      default: true,
    },
    loadData: {
      type: Boolean,
      default: false,
    },
    dataTestId: {
      type: String,
      default: '',
    },
    isChips: {
      type: Boolean,
      required: false,
      default: true,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  mounted(): void {
    Vue.nextTick(() => {
      this.fieldValue = this.getValue;
      this.getValueType();
    });
  },
  watch: {
    getValue: function () {
      this.fieldValue = this.getValue;
    },
    typeValue() {
      this.getValueType();
    },
  },
  computed: {
    getId(): string {
      if (!this.name) {
        return '_' + Math.random().toString(36).substr(2, 9);
      }
      return this.name.replace('[', '-').replace(']', '').toLowerCase();
    },
    checkValueIsObject(): boolean {
      return this.value.some((v) => v.value);
    },
    getValue(): Array<OptionsFieldInterface> {
      if (!this.checkValueIsObject) {
        return this.options.filter((item: OptionsFieldInterface): boolean => {
          if (!this.value && this.value !== 0) {
            return false;
          }
          return (
            undefined !==
            this.value.find((element) => {
              return item.value == element;
            })
          );
        });
      }

      return [...this.value];
    },
    issetLabel(): boolean {
      return !!this.label && this.label !== '';
    },
    isFilled(): boolean {
      return !!this.fieldValue.length;
    },
    error(): string {
      return this.errors.join(', ');
    },
  },
  methods: {
    input(value) {
      const values = this.fieldValue.map((item: OptionsFieldInterface) => {
        return item.value;
      });
      this.$emit('input', values);
      this.changeEvent(values);
      this.returnObject(value);
    },
    returnObject(value) {
      this.$emit('returnObject', value);
    },
    changeEvent(values: Array<string | number>) {
      if (this.isTypeSelect) {
        this.$emit('change', { value: values, type: this.typeSelected?.value });
        return;
      }
      this.$emit('change', values);
    },
    changeType() {
      this.$emit('changeType', this.typeSelected?.value);
    },
    onSearch(search: string, loading: (param: boolean) => void) {
      loading(true);
      this.search(search, loading);
    },
    search(search: string, loading: (param: boolean) => void) {
      this.$emit('search', search);
      loading(false);
    },
    focus(data) {
      this.$emit('focus', data);
    },
    getValueType() {
      const typeValue = this.typeOptions.find(
        (type) => type.value === this.typeValue
      );

      if (typeValue) {
        this.typeSelected = typeValue;
      }
    },
    searchChange(value) {
      this.$emit('searchChange', value);
    },
    close() {
      this.$emit('close');
    },
    open() {
      this.$emit('open');
    },
    getLabelFromOptions(item) {
      return this.options.find((itm) => itm.value === item)?.label || '';
    },
    removeValue(item) {
      const newValues = this.fieldValue.filter((itm) => {
        if (item.value) {
          return item.value !== itm.value;
        }

        return itm.value !== item;
      });

      this.fieldValue = newValues;
      this.input(newValues);
    },
  },
  data: function () {
    return {
      fieldValue: [] as Array<any>,
      typeSelected: {
        label: this.$t('body.form.input.include'),
        value: typeMultiselect.INCLUDE,
      },
      typeOptions: [
        {
          label: this.$t('body.form.input.include'),
          value: typeMultiselect.INCLUDE,
        },
        {
          label: this.$t('body.form.input.exclude'),
          value: typeMultiselect.EXCLUDE,
        },
      ],
    };
  },
});
